import { useTranslation } from 'react-i18next';
import { isElectron } from 'utils/isElectron';
import { GuardedComponent, GuardedComponentProps } from './GuardedComponent';

// export interface WebComponentProps extends React.PropsWithChildren<{}> {
//   fallback?: React.ReactElement;
//   hideOnClient?: boolean;
// }

// export function WebComponent({ hideOnClient, fallback, ...rest }: WebComponentProps) {
//   const { t } = useTranslation();

//   if (!isElectron()) {
//     return rest.children as JSX.Element;
//   }

//   if (hideOnClient) {
//     return <></>;
//   }

//   const children = injectPropsToChildren<{ disabled?: boolean }>(rest.children, { disabled: true });

//   return (
//     <Tooltip title={t('featureWeb', 'Feature only available on the web')}>
//       <span>{fallback ? fallback : children}</span>
//     </Tooltip>
//   );
// }

export interface WebComponentProps extends Omit<GuardedComponentProps, 'allowed' | 'message'> {
  hideOnClient?: boolean;
}

export function WebComponent({ fallback, hideOnClient, mode, children }: WebComponentProps) {
  const { t } = useTranslation();

  return (
    <GuardedComponent
      allowed={!isElectron()}
      hide={hideOnClient}
      fallback={fallback}
      mode={mode}
      message={t('featureWeb', 'Feature only available on the web')}
    >
      {children}
    </GuardedComponent>
  );
}
